import Axios from "axios";
import { BRAND } from "@core/brand/brand-config";
import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import trackingEventDictionary from "../../../core/dictionary/tracking-event";
import { MONTH_ENUM, REQUEST_SOURCE } from "../../../core/dictionary/global";
import RequestCenterFilter from "./Request-center-filter";
import ReactTooltip from "react-tooltip";
import NoSearchDataComponent from "../../../shared/country-components/no-search-data";
import { getApiUrl } from "../../../utils/baseUrl";
import ReactTableTrademo from "@shared/trademo-datatable/react-table-trademo";
import { getTitleCase } from "@utils/utils";
import LoaderImg from "@assets/images/loader.gif";
import { captureException } from "@sentry/react";

const apiEndpoint = {
  getDownloadShipments: getApiUrl("getDownloadShipments"),
  notification_center: getApiUrl("notification_center/get_notifications"),
};

const sortEnum = [{ columnKey: "requestDate", value: "requestDate" }];

const RequestContact = ({ status, setStatus, requestType, setRequestType, showStatus, showRequest, setShowRequest, setShowStatus, propsDataList, selectDataHandler, callingTrackingEvents, loader }) => {
  const [showModal, setShowModal] = useState(false);
  const [row, setRow] = useState(null);
  const [column, setColumn] = useState();
  const [statusCount, setStatusCount] = useState(0);
  const [reqTypeCount, setReqTypeCount] = useState(0);
  const [dataList, setDataList] = useState([]);
  const [innerStatus, setInnerStatus] = useState({});
  const [innerRequestType, setInnerRequestType] = useState({});
  const [currentpage, setCurrentpage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortValue, setSortValue] = useState(sortEnum[0].value);
  const [sortOrderValue, setSortOrderValue] = useState("desc"); // Default to descending

  useEffect(() => {
    if (!!propsDataList && propsDataList.length) {
      const searchUrlParams = window.location.search;
      if (!!new URLSearchParams(searchUrlParams).get("requestId") && +new URLSearchParams(searchUrlParams).get("activeIndex") === 0) {
        let requestId = new URLSearchParams(searchUrlParams).get("requestId");
        let row = propsDataList.find((item) => item.requestId.toString() === requestId);
        if (!!row && Object.keys(row).length) {
          setRow(row);
          setTimeout(() => {
            setShowModal(true);
          }, 100);
        }
      }
    }
    setDataList(propsDataList);
  }, [propsDataList]);

  useEffect(() => {
    setColumnHandler();
  }, [showStatus, showRequest, propsDataList, dataList, innerRequestType, innerStatus]);

  useEffect(() => {
    setInnerRequestType(requestType);
    setInnerStatus(status);
  }, [status, requestType]);

  useEffect(() => {
    let pagination = document.querySelectorAll(".rdt_Pagination");
    if (!!pagination && !!pagination.length && !!dataList) {
      if (dataList.length === 1) {
        pagination[0].style.marginTop = "-147px";
      } else if (dataList.length === 2) {
        pagination[0].style.marginTop = "-88px";
      } else if (dataList.length > 2) {
        pagination[0].style.marginTop = "0px";
      }
    }
  }, [dataList]);
  const handlePageChange = (page, rowsPerPage) => {
    setCurrentpage(page);
    setPerPage(rowsPerPage);
  };

  const setColumnHandler = () => {
    setColumn([
      {
        name: "View",
        selector: (row) => (
          <div
            onClick={() => {
              setShowModal(true);
              setRow(row);
              callingTrackingEvents(trackingEventDictionary.requestCentreContactsExpandRequest);
              if (!row.isViewed) {
                selectDataHandler(row, REQUEST_SOURCE[0]);
              }
            }}
            className="ml-2 cursor-pointer">
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684498944/intel/icons/zoom_out_map_dbigrl.svg" />
          </div>
        ),
        maxWidth: "50px",
        minWidth: "50px",
      },
      {
        key: "s_no",
        name: "S. No",
        selector: "sNo",
        maxWidth: "60px !important",
        minWidth: "50px !important",
        format: (row) => <div className="ml-2">{row.sNo}</div>,
        grow: 2,
      },
      {
        name: "Request ID",
        selector: "requestId",
        wrap: true,
        grow: 1,
        format: (row) => (
          <span>
            {row.requestId}
            {!row.isViewed && row.status.toLowerCase().includes("closed") ? <img className="ml-1" src="https://res.cloudinary.com/drzta9shk/image/upload/v1671105392/intel/icons/icon-new-badge_gdiz3b.svg" /> : ""}
          </span>
        ),
      },
      {
        name: "Request Date",
        key: "requestDate",
        wrap: true,
        selector: (row) => <div>{`${MONTH_ENUM[new Date(row.requestDate).getMonth()]} ${new Date(row.requestDate).getDate()}, ${new Date(row.requestDate).getFullYear()}`}</div>,
        grow: 1,
        sortable: true,
      },
      {
        name: (
          <span
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="position-relative cursor-pointer">
            <span
              onClick={() => {
                setShowRequest(!showRequest);
                setShowStatus(false);
                callingTrackingEvents(trackingEventDictionary.requestCentreRequestTypeFilter);
              }}>
              Request Type <span className="material-symbols-outlined">filter_alt</span>
            </span>
            {reqTypeCount ? (
              <span className="green-badge">
                <span>{reqTypeCount}</span>
                <span onClick={() => clearFilterhandler(requestType)} className="pl-1">
                  X
                </span>
              </span>
            ) : null}
            <span>{showRequest ? <RequestCenterFilter isDownload={true} onChangeHandler={filterByRequestTypeHandler} data={requestType} /> : null}</span>
          </span>
        ),
        wrap: true,
        grow: 1,
        selector: (row) => (
          <span className="tw-capitalize">
            {Array.isArray(row.companyName) && row.companyName?.length > 1 ? "Bulk - " : ""}
            {row.requestType === "bulk" ? "Employee Level Contacts" : row.requestType}
          </span>
        ),
      },
      {
        name: "Request Contacts",
        wrap: true,
        selector: (row) => (
          <div>
            <p className="m-0">{row.contactsRequested} contacts requested for</p>
            <p className="m-0">{!Array.isArray(row.companyName) ? row.companyName : <span data-tip={row.companyName.join(" | ")} data-for={"companieslist"} className="request_company_list">{`${row.companyName.length} companies`}</span>}</p>
            <ReactTooltip className="trademo-tooltip" id="companieslist" />
          </div>
        ),
        grow: 2,
      },
      {
        name: (
          <span>
            <span
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setShowStatus(!showStatus);
                setShowRequest(false);
                callingTrackingEvents(trackingEventDictionary.requestCentreRequestTypeStatus);
              }}>
              Status <span className="material-symbols-outlined">filter_alt</span>
            </span>
            {statusCount ? (
              <span className="green-badge cursor-pointer">
                <span>{statusCount}</span>
                <span onClick={() => clearFilterhandler(status)} className="pl-1">
                  X
                </span>
              </span>
            ) : null}
            {showStatus ? <RequestCenterFilter isDownload={true} onChangeHandler={filterByStatusHandler} data={status} /> : null}
          </span>
        ),
        wrap: true,
        selector: (row) => (
          <div>
            <p className="m-0 request_status tw-capitalize">{getTitleCase(row.status)}</p>
            <p className="m-0">{getStatusHandler(row)}</p>
          </div>
        ),
        grow: 2,
      },
      {
        name: "Action",
        wrap: true,
        minWidth: "110px !important",
        selector: (row) => (
          <div
            onClick={() => {
              if (row.downloadUrl) {
                callingTrackingEvents(trackingEventDictionary.requestCentreActionDownload);
                downloadDownloadedFiles(row.downloadUrl);
              }
            }}
            className="cursor-pointer">
            {row.downloadUrl ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684499098/intel/icons/cloud_download_1_ouqfdy.svg" /> : "-"}
          </div>
        ),
      },
    ]);
  };

  const contactsHandler = () => {
    if (row.status.includes("closed")) {
      return (
        <p className="m-0">
          Max {row.contactsRequested === 1 ? 1 : row.contactsRequested} contacts requested for {row.companiesRequested === 1 ? "" : "each"} {row.companiesRequested === 1 ? row.companyName : row.companiesRequested} companies
        </p>
      );
    } else {
      return (
        <p className="m-0">
          Max {row.contactsRequested} contacts requested {row.companiesRequested === 1 ? "" : "each"} for {row.companiesRequested === 1 ? row.companyName : row.companiesRequested} companies
          {/* Max   {row.companiesRequested === 1 ? row.companyName : row.companiesRequested} companies, {row.contactsRequested} contacts */}
        </p>
      );
    }
  };

  const getDescriptionHandler = () => {
    if (row.status.includes("closed")) {
      if (row.status === "closed - Contacts Not Found" || row.status === "closed - Contacts Not Received") {
        return (
          <div>
            Your request to fetch contacts for {row.companiesRequested === 1 ? row.companyName : row.companiesRequested} companies had been closed on{" "}
            {`${MONTH_ENUM[new Date(row.responseDate).getMonth()]} ${new Date(row.responseDate).getDate()}, 
                    ${new Date(row.responseDate).getFullYear()}`}{" "}
            at {new Date(row.responseDate).getHours().toString().length === 1 ? "0" + new Date(row.responseDate).getHours().toString() : new Date(row.responseDate).getHours().toString()}:{new Date(row.responseDate).getMinutes().toString().length === 1 ? "0" + new Date(row.responseDate).getMinutes().toString() : new Date(row.responseDate).getMinutes().toString()} {new Date(row.responseDate).getHours() > 12 ? "PM" : "AM"} EST.
            <p>It seems we were not able to fetch you any new contacts.</p>
            <p>Alternatively, you can try modifying your search criteria to help us get you best results.</p>
          </div>
        );
      }
      return (
        <div className="m-0">
          <p>
            Your request to fetch contacts for {row.companiesRequested === 1 ? row.companyName : row.companiesRequested} companies had been successfully closed on <strong>{`${MONTH_ENUM[new Date(row.responseDate).getMonth()]} ${new Date(row.responseDate).getDate()}, ${new Date(row.responseDate).getFullYear()}`}</strong> at {new Date(row.responseDate).getHours()}:{new Date(row.responseDate).getMinutes()} {new Date(row.responseDate).getHours() > 12 ? "PM" : "AM"} EST. We found {row.contactsFound} contacts for {row.companiesRequested === 1 ? row.companyName : row.companiesRequested} companies which are now ready for you to download. Additionally, you can also view these contacts in -{" "}
          </p>
          <ul className="pl-3">
            <li>Viewed Contacts tab in the respective Company Profile</li>
            <li>Address Book in your {BRAND.name} Dashboard</li>
          </ul>
        </div>
      );
    } else {
      return (
        <p className="m-0">
          We are working on your requested contacts. You can expect it to be delivered within <strong>{!!row.responseTime && row.responseTime.split(" ")[0]} business hours</strong>
        </p>
      );
    }
  };

  const getStatusHandler = (row) => {
    if (row.status.includes("closed")) {
      if (row.contactsFound === 0) {
        return (
          <p className="m-0 d-flex items-center ">
            <span className="mr-2">No contact found for requested criteria</span> <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684499264/intel/icons/warning_org_okb3rg.svg" />
          </p>
        );
      } else {
        return (
          <p className="m-0 d-flex items-center ">
            <span className="mr-2">
              Total {row.contactsFound} contacts found for {row.companiesRequested} companies
            </span>{" "}
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684499206/intel/icons/check_circle_ndi8es.svg" />
          </p>
        );
      }
    } else {
      return `Expected Delivery By ${row.responseTime}`;
    }
  };
  const clearFilter = () => {
    let statusValue = "";
    let reqTypeValue = "";
    setStatusCount(0);
    setReqTypeCount(0);
    let statusClone = JSON.parse(JSON.stringify(status));
    let requestTypeClone = JSON.parse(JSON.stringify(requestType));

    requestTypeClone.map((item) => {
      if (item.isChecked) {
        item.isChecked = false;
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        item.isChecked = false;
      }
    });
    setStatus(statusClone);
    setRequestType(requestTypeClone);
    setTimeout(() => {
      applyFilterHandler("", statusValue.toLowerCase(), reqTypeValue.toLowerCase());
    }, 200);
  };

  const applyFilterHandler = (type, stat, req) => {
    Axios.get(apiEndpoint.notification_center + `?source=contacts&is_notification=false&status=${stat}&request_type=${req}&order=desc`).then(({ data: { data } }) => {
      if (type === "status") {
        let reqTypeClone = JSON.parse(JSON.stringify(requestType));
        reqTypeClone.forEach((item, index) => {
          let reqVal = data.data.some((val) => val.requestType.toLowerCase().includes(item.name.toLowerCase()));
          if (!reqVal) {
            reqTypeClone.splice(index, 1);
          }
        });
        setInnerRequestType(reqTypeClone);
      } else if (type === "requestType") {
        let statusClone = JSON.parse(JSON.stringify(status));
        status.map((item, index) => {
          let reqVal = data.data.some((val) => val.status.toLowerCase().includes(item.name.toLowerCase()));
          if (!reqVal) {
            statusClone.splice(index, 1);
          }
        });
        setInnerStatus(statusClone);
      }
      let altData = [];
      altData = data.data.map((item, index) => {
        return { ...item, sNo: index + 1 };
      });
      if (Math.ceil((perPage * currentpage) / altData.length) >= currentpage) {
        setCurrentpage(1);
      }
      setDataList(altData);
    });
  };

  const filterByStatusHandler = (index) => {
    let statusClone = JSON.parse(JSON.stringify(status));
    let requestTypeClone = JSON.parse(JSON.stringify(requestType));
    let requestValue = "";
    let statusValue = "";
    if (statusClone[index].isChecked) {
      statusClone[index].isChecked = false;
      setStatusCount(statusCount - 1);
    } else {
      statusClone[index].isChecked = true;
      setStatusCount(statusCount + 1);
    }
    setStatus(statusClone);
    requestTypeClone.map((item) => {
      if (item.isChecked) {
        requestValue += item.payload + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });

    setTimeout(() => {
      applyFilterHandler("status", statusValue.toLowerCase(), requestValue.toLowerCase());
    }, 200);
  };

  const filterByRequestTypeHandler = (index) => {
    let requestTypeClone = JSON.parse(JSON.stringify(requestType));
    let statusClone = JSON.parse(JSON.stringify(status));
    let requestValue = "";
    let statusValue = "";
    if (requestTypeClone[index].isChecked) {
      requestTypeClone[index].isChecked = false;
      setReqTypeCount(reqTypeCount - 1);
    } else {
      requestTypeClone[index].isChecked = true;
      setReqTypeCount(reqTypeCount + 1);
    }
    setRequestType(requestTypeClone);
    requestTypeClone.map((item) => {
      if (item.isChecked) {
        requestValue += item.payload + ",";
      }
    });
    statusClone.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });
    setTimeout(() => {
      applyFilterHandler("requestType", statusValue.toLowerCase(), requestValue.toLowerCase());
    }, 200);
  };

  const clearFilterhandler = (type) => {
    let requestVal = JSON.parse(JSON.stringify(requestType));
    let statusType = JSON.parse(JSON.stringify(status));
    if (type[0].payload === "single" || type[0].payload === "bulk") {
      setReqTypeCount(0);
      requestType = requestVal.map((item) => ({ ...item, isChecked: false }));
      setInnerRequestType(requestType);
      setReqTypeCount(0);
      setRequestType(requestType);
    } else {
      setStatusCount(0);
      statusType = statusType.map((item) => ({ ...item, isChecked: false }));
      setStatusCount(0);
      setInnerStatus(statusType);
      setStatus(statusType);
    }

    let requestValue = "";
    let statusValue = "";

    requestType.map((item) => {
      if (item.isChecked) {
        requestValue += item.payload + ",";
      }
    });
    statusType.map((item) => {
      if (item.isChecked) {
        statusValue += item.name + ",";
      }
    });
    setTimeout(() => {
      applyFilterHandler("requestType", statusValue.toLowerCase(), requestValue.toLowerCase());
    }, 200);
  };

  const downloadDownloadedFiles = (data) => {
    if (!!data && data !== "") {
      const params = {
        file_name: data,
      };
      const apiUrl = apiEndpoint.getDownloadShipments;
      Axios.get(apiUrl, { params }).then(
        (res) => {
          if (!!res && !!res.data && !!res.data.status && res.data.status.toLocaleUpperCase() === "SUCCESS".toLocaleUpperCase()) {
            window.open(res.data.data.file_url);
          } else {
            toast.error(res.data.message);
          }
        },
        (error) => {
          captureException(error);
          toast.error("Something went wrong. Please try again later!!!");
        }
      );
    } else {
      toast.error("Something went wrong. Please try again later !!!");
    }
  };

  const applyAllFilters = () => {
    let filteredData = [...dataList];

    if (sortValue && sortOrderValue) {
      if (sortValue === "requestDate") {
        filteredData.sort((a, b) => {
          const dateA = new Date(a.requestDate);
          const dateB = new Date(b.requestDate);

          if (sortOrderValue === "asc") {
            return dateA - dateB;
          } else {
            return dateB - dateA;
          }
        });
      }
    }

    filteredData = filteredData.map((item, index) => {
      return { ...item, sNo: index + 1 };
    });

    setDataList(filteredData);
    setCurrentpage(1);
  };

  const handleSorting = (column, sortDirection) => {
    setSortValue(column);
    setSortOrderValue(sortDirection);

    applyAllFilters();
  };

  return (
    <div className={`request_center_container ${loader ? "tw-flex tw-justify-center tw-items-center" : ""}`}>
      {loader ? (
        <img src={LoaderImg} alt="description of gif" />
      ) : !propsDataList.length && loader === false ? (
        <div className="">
          <div className="no-data-found-container">
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684997941/intel/icons/emptystate_norequest_b1wzx6.svg" />
            <p>You have not raised any requests yet!</p>
            <p>
              This <strong>Request Centre</strong> will show information on all your raised requests in detail which you can view as per your customised preferences
            </p>
          </div>
        </div>
      ) : !loader ? (
        <div>
          <p className="request_center_heading">All contact requests</p>
          {!!column && column.length ? (
            <div className="tw-border tw-border-gray-200 tw-rounded-2xl tw-overflow-hidden">
              <ReactTableTrademo
                columns={column}
                data={dataList.length > 0 ? dataList : []}
                paginationTotalRows={dataList.length}
                onSelectedRowsChange={() => null}
                onSort={handleSorting}
                defaultSortField={sortValue}
                defaultSortAsc={sortOrderValue === "desc" ? false : true}
                paginationPerPage={perPage}
                paginationDefaultPage={currentpage}
                selectedData={[]}
                sortOrderValue={sortOrderValue}
                shipmentDefaultSortValue={sortEnum}
                onChangeRowsPerPage={(perPage) => handlePageChange(currentpage, perPage)}
                onTableObjectChange={(data) => {
                  setPerPage(data.perPage);
                  setCurrentpage(data.currentPage + 1);
                }}
                onChangePage={(page) => handlePageChange(page, perPage)}
                noDataComponent={<NoSearchDataComponent content="No requests for contacts found." />}
                hideSelection={true}
                hideSorting={true}
                isAtleastTwoColumnsSorted={true}
                clearFilter={clearFilter}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}

      {showModal ? (
        <Modal size="lg" centered show={showModal} onHide={() => setShowModal(false)} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Request Details for {row.requestId}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            <div className="row m-0 px-4 mt-4">
              <div className="col-4 p-0">
                <p className="m-0">Request Date</p>
                <p className="m-0 notification_modal_data">{`${MONTH_ENUM[new Date(row.requestDate).getMonth()]} ${new Date(row.requestDate).getDate()}, ${new Date(row.requestDate).getFullYear()}`}</p>
              </div>
              <div className="col-4 p-0">
                <p className="m-0">Request Type</p>
                <p className="m-0 notification_modal_data">
                  {Array.isArray(row.companyName) && row.companyName?.length > 1 ? "Bulk - " : ""} {row.requestType === "bulk" ? "Employee Level Contacts" : row.requestType}
                </p>
              </div>
              <div className="col-4 p-0">
                <p className="m-0">{row.status.includes("closed") ? "Requested Contacts" : "Number of Records Requested"} </p>
                <p className="m-0 notification_modal_data_contact">{contactsHandler()}</p>
              </div>
            </div>
            <div className="mt-4 mb-4">
              <div className="row m-0 px-4">
                <div className="col-4 p-0">
                  <p className="m-0 notification_modal_header">Request Status</p>
                  <p className="m-0 notification_modal_data ">{row.status}</p>
                </div>
              </div>
            </div>
            <div className="notification_body_handler px-4 py-4 ">{getDescriptionHandler()}</div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2"
              onClick={() => {
                setShowModal(false);
                callingTrackingEvents(trackingEventDictionary.requestCentreContactsExpandRequestClose);
              }}>
              Close
            </button>
            {row.downloadUrl ? (
              <button
                type="button"
                className="btn btn-primary btn-sm trademo-new-btn"
                onClick={() => {
                  if (row.downloadUrl) {
                    callingTrackingEvents(trackingEventDictionary.requestCentreContactsExpandRequestDownload);
                    downloadDownloadedFiles(row.downloadUrl);
                  }
                }}>
                Download Link
              </button>
            ) : null}
          </Modal.Footer>
        </Modal>
      ) : (
        <></>
      )}
    </div>
  );
};

export default RequestContact;
